import * as React from 'react'
import { Props } from './types'
import moment from 'moment'
import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils from 'react-day-picker/moment';
import {
  // @ts-ignore
  formatDate,
  // @ts-ignore
  parseDate,
} from "react-day-picker/moment";
import './styles.scss'
// @ts-ignore
import "moment/locale/fr";
/**
 * @description
 * @author Jonathan IBOR
 * @export
 * @class DayPicker
 * @extends {React.Component<Props>}
 */
export class DayPicker extends React.Component<Props> {
  format: string

  constructor(props: Props) {
    super(props)

    this.state = {};

    this.format = 'DD MMMM YYYY'

    this.onHandleDayChange = this.onHandleDayChange.bind(this)
  }

  onHandleDayChange(day: Date) {
    const { selectedDay } = this.props

    selectedDay(day);
  }

  render() {
    const {
      label,
      placeholder,
      initialValue,
      icon: Icon,
      disabledDays,
    } = this.props

    let date = '';

    if (typeof initialValue === "number") {
      date = moment?.unix(initialValue).format(this.format);
    } else {
      date = moment?.utc().format(this.format);
    }

    return (
      <div className="DayPicker-wrapper">
        <div className="daypicker-label">{label}</div>
        <div style={{ position: "relative" }}>
          <DayPickerInput
            placeholder={placeholder}
            formatDate={formatDate}
            parseDate={parseDate}
            value={typeof initialValue === 'number' && initialValue > 0 ? date : ''}
            format={this.format}
            onDayChange={(day: Date) => this.onHandleDayChange(day)}
            dayPickerProps={{
              captionElement: (props) => {
                return (
                  <form className="DayPicker-Caption">
                    <div>
                      {moment(props.date)
                        .locale("fr")
                        .format("MMMM YYYY")}
                    </div>
                  </form>
                );
              },
              disabledDays: disabledDays || [],
              locale: "fr",
              localeUtils: MomentLocaleUtils
            }}
          />
          {Icon && <div className="DayPicker-icon">{Icon}</div>}
        </div>
      </div>
    );
  }
}
